import Beebox3DLanding from './Beebox3DLanding';

function App() {
  return (
    <div className="App">
     <Beebox3DLanding/>
    </div>
  );
}

export default App;
